import { convertDeliveryStatusToInternalName } from 'lib/constants';
import { Ticket } from 'types/User/firebaseTypes/ticket';

/**
 * Simple check if a ticket is in 'done' or 'archived' status. Tickets with
 * such statuses can be assumed to be resolved
 * @param ticket
 * @returns {boolean}
 */
export const isResolved = (ticket: Ticket): boolean => {
    if (!ticket.status) {
        return false;
    }

    const normalizedStatus = convertDeliveryStatusToInternalName[ticket.status];

    return normalizedStatus === 'done' || normalizedStatus === 'archived';
};
